// extracted by mini-css-extract-plugin
export var button = "button-module--button--jjrpT";
export var button_small = "button-module--button_small--sYtHm";
export var button_normal = "button-module--button_normal--fReaL";
export var button_medium = "button-module--button_medium--LBDJj";
export var button_large = "button-module--button_large--64j4k";
export var button_blue = "button-module--button_blue--+7LMk";
export var button_white = "button-module--button_white--1fODs";
export var button_transparent = "button-module--button_transparent--RhQhb";
export var isFullWidth = "button-module--isFullWidth--N4-B-";